import { breakpoints } from '@/theme/tokens'
import { TripOverviewSection } from './core'

/** Which viewport layout the bento renders in. */
export type BentoLayout = 'desktop' | 'mobile'

/** Desktop source order — yields the approved 12-col auto-placement. */
const DESKTOP_ORDER = [
	'itinerary',
	'money',
	'ideas',
	'accommodations',
	'flights',
	'files',
] as const satisfies readonly TripOverviewSection[]

/** Mobile stack order — a deliberate reorder (not a pure CSS collapse). */
const MOBILE_ORDER = [
	'money',
	'itinerary',
	'ideas',
	'accommodations',
	'flights',
	'files',
] as const satisfies readonly TripOverviewSection[]

/** Resolves to `true` only when the array covers every `TripOverviewSection`. */
type CompleteOrder<T extends readonly TripOverviewSection[]> =
	Exclude<TripOverviewSection, T[number]> extends never
		? true
		: ['section missing from this order:', Exclude<TripOverviewSection, T[number]>]

// Exported so the unit tests can pin the guards; the real check is the compile.
export const DESKTOP_ORDER_COMPLETE: CompleteOrder<typeof DESKTOP_ORDER> = true
export const MOBILE_ORDER_COMPLETE: CompleteOrder<typeof MOBILE_ORDER> = true

/** The ordered section keys to render for a given layout. */
export const orderedSections = (layout: BentoLayout): readonly TripOverviewSection[] =>
	layout === 'mobile' ? MOBILE_ORDER : DESKTOP_ORDER

/** Width (px) at/below which the bento collapses to the mobile stack. */
export const BENTO_COLLAPSE_PX: number = breakpoints.bentoCollapse
